import { LegacyMasqueradeBanner } from "@/react/components/MasqueradeBanner/LegacyMasqueradeBanner";
import { MasqueradeBannerV4 } from "@/react/components/MasqueradeBanner/MasqueradeBannerV4";
import { useMasqueradeContext } from "@/react/contexts/masqueradeContext";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useIsLoadingAppData } from "@/react/hooks/useIsLoadingAppData";
import { useBackendProps } from "@/react/providers/AppContext";

export const MasqueradeBanner = ({
  isCompact = false,
}: {
  isCompact?: boolean;
}) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { isBannerVisible } = useMasqueradeContext();
  const { masquerade_referrer_url: masqueradeReferrerUrl } = useBackendProps();
  const isLoadingAppData = useIsLoadingAppData();
  if ((!masqueradeReferrerUrl || isLoadingAppData) && !isBannerVisible)
    return null;

  if (currentCommunitySettings?.masquerade_banner_v4_enabled) {
    return <MasqueradeBannerV4 isCompact={isCompact} />;
  }
  return <LegacyMasqueradeBanner isCompact={isCompact} />;
};
